





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CommunicationsClient, ReceiverType } from '@/data/web-api-client';
import moment from 'moment';
import settings from '@/settings.json';

@Component({
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
})
export default class CommunicationTypeMail extends Vue {
  @Prop({ required: true })
  item!: any;
  renderEmailUrl: string = '';

  ReceiverType: any = ReceiverType;

  mounted() {}

  getFormatDate(date: Date) {
    return moment(date).format('DD/MM/YYYY HH:mm');
  }

  openEmail(item: any) {
    this.$emit('openMail', item);
  }

  async deleteCommunication(id: string) {
    this.$emit('deleted', id);
  }

  downloadAttachment(attachment: any) {
    return settings.api + '/api' + `/Communications/Open?blobUrl=${attachment.blobName}&fileName=${attachment.fileName}&container=uploads`;
  }
}
